module.exports = __webpack_public_path__ + "img/icon_beat.437d70f6.svg";